import { ConnectionItem, Flex, Image, Text } from "@wayflyer/flyui";
import { useState } from "react";
import { useIntl } from "react-intl";
import { connectByPath } from "../../../data-sources";
import { useCustomerAppConfig } from "undercarriage";

import { usePlatformConnectorProperties } from "../../queries";
import { useConnectionFlowsConfig } from "../../config";
import { COMMON_MESSAGES } from "../../common-messages";
import { ConnectionsList } from "../../common/connections";
import { OAuthErrorBanner } from "../../common/oauth-error-banner";
import { MESSAGES } from "../../messages";

const CONNECTOR_SLUG = "xero";

export const XeroConnect = ({ onInitiateConnection }: { onInitiateConnection?: () => void }) => {
  const intl = useIntl();
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();
  const { connectorsApiUrl, defaultCallbackPath } = useConnectionFlowsConfig();
  const { data: connectorProperties } = usePlatformConnectorProperties(
    customerDomain,
    CONNECTOR_SLUG,
    defaultCallbackPath,
    connectorsApiUrl
  );
  const [connectionInProgress, setConnectionInProgress] = useState(false);

  return (
    <Flex direction="column" gap="8">
      <Flex direction="column" gap="8" align="flex-start" justify="space-between">
        <OAuthErrorBanner connectorSlug={CONNECTOR_SLUG} />
        <Text>{intl.formatMessage(MESSAGES.accountingPlatformDataUsage)}</Text>
        <ConnectionsList
          connectorProperties={connectorProperties}
          connectForm={
            <ConnectionItem
              logo={
                connectorProperties.connectionLogoSrc ? <Image src={connectorProperties.connectionLogoSrc} /> : null
              }
              label={connectorProperties.name}
              loading={connectionInProgress}
              actions={[
                {
                  variant: "Tertiary",
                  content: intl.formatMessage(COMMON_MESSAGES.connectAccount),
                  onAction: () => {
                    onInitiateConnection?.();
                    setConnectionInProgress(true);
                    connectByPath(connectorProperties?.connectPath);
                  },
                },
              ]}
            />
          }
        />
      </Flex>
    </Flex>
  );
};
